/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketDropdowns } from '../../models/support-ticket-dropdowns';

export interface GetTicketFilterDropdowns$Params {
}

export function GetTicketFilterDropdowns(http: HttpClient, rootUrl: string, params?: GetTicketFilterDropdowns$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketDropdowns>> {
  const rb = new RequestBuilder(rootUrl, GetTicketFilterDropdowns.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketDropdowns>;
    })
  );
}

GetTicketFilterDropdowns.PATH = '/api/Tickets/GetTicketFilterDropdowns';
